@if (showMenu) {
  <div class="screen-print">
    @if (!logoLink) {
      <img src="../assets/russellTreeBackground.png" alt="Arbor Answers Logo" id="logo" style="padding: .4em;">
    }
    @if (logoLink) {
      <a [href]="logoLink"><img src="../assets/russellTreeBackground.png"  alt="Arbor Answers Logo" id="logo" style="padding: .4em;"></a>
    }
    @if (isLoggedIn) {
      <div class="menubarLg">
        <p-menubar [model]="items" [autoDisplay]="false">
          @if (token.userType !== 'customer') {
            <span>
              Hello, <a target="_blank" class="regular-link" (click)="nameClicked()">{{token.given_name}}</a>!
            </span>
          }
          @if (token.userType === 'customer') {
            <span>Hello, {{token.given_name}}!</span>
          }
          @if (token && token.userType == 'customer') {
            <span>
              <p-button severity="secondary" class=" pad-left" style="padding-right: 40px;"
              icon="pi pi-home" (click)="customerPage()"></p-button>
              <p-button severity="secondary" class="pad-left" label="Request a Quote"
              (click)="requestAQuote()"></p-button>
            </span>
          }
          <p-button class="pad-left" label="Logout" severity="secondary" 
          (click)="onLogout()"></p-button>
        </p-menubar>
      </div>
    }
    @if (isLoggedIn) {
      <div class="slide-menu-option">
        <p-button (click)="showSlideMenu=true" severity="secondary" class="slide-menu-button" 
        icon=" fa fa-bars"></p-button>
        <div>
          @if (token && token.userType !== 'customer') {
            <p-drawer [(visible)]="showSlideMenu" position="right">
              <p-scrollpanel [style]="{width: '100%', height: '100%'}">
                <div style="margin-bottom: .5em">
                  @if (token.userType !== 'customer') {
                    <span>
                      Hello, <a target="_blank" class="regular-link" (click)="nameClicked()">{{token.given_name}}</a>!
                    </span>
                  }
                  @if (token.userType === 'customer') {
                    <span>Hello, {{token.given_name}}!</span>
                  }
                  <p-button severity="secondary" class="pad-left"
                  label="Logout" (click)="onLogout()"></p-button>
                </div>
                <p-panelMenu class="panel-menu" [model]="items" [style]="{'width':'100%'}" [multiple]="false"></p-panelMenu>
              </p-scrollpanel>
            </p-drawer>
          }
          @if (token && token.userType === 'customer') {
            <p-drawer [(visible)]="showSlideMenu" [showCloseIcon]="false" position="right"
              >
              <div class="burger-title">
                <div><i class="pi pi-user"></i> Hello, {{token.given_name}}</div>
                <div (click)="showSlideMenu=false"><i class="pi pi-times"></i></div>
              </div>
              <div class="mobile-burger-container">
                <div (click)="customerPage()">Home</div>
                <div (click)="requestAQuote()">Request a Quote</div>
                <div (click)="onLogout()">Logout</div>
              </div>
            </p-drawer>
          }
        </div>
      </div>
    }
  </div>
}
@if (environment) {
  <div class="env-banner screen-print">
    <p-message severity="warn" text="This is a non-production environment: {{environment}}"></p-message>
  </div>
}
<div>
  <br />
  <br />
  <br />
</div>

<div class="main-content">
  <p-toast position="top-center"></p-toast>
  <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>
  <router-outlet></router-outlet>
</div>
